import React, { useEffect, useState } from 'react'
import { useClickStore } from '../../store/clickStore';
import { useShallow } from 'zustand/react/shallow';
import SidebarScene from './SidebarScene';
import StopeChart from './StopeChart';
import StopeGeology from './StopeGeology';
import JSZip from 'jszip';
import * as d3 from 'd3';

export default function ObjectDetailsPage() {
    const [data,setData] = useState([]);
    const [isAttributesOpen, setIsAttributesOpen] = useState(false);
    const [isStopeChartOpen, setIsStopeChartOpen] = useState(false);
    const [isGeologyOpen, setIsGeologyOpen] = useState(false);

      const {objectDetails,objectDetailsPosition,objectDetailsObject,clickType} = useClickStore(useShallow((state)=>({
        objectDetails:state.objectDetails,
        objectDetailsPosition:state.objectDetailsPosition,
        objectDetailsObject:state.objectDetailsObject,
        clickType:state.clickType,
    })))

    useEffect(()=>{
        let detailsArr = []
        if(objectDetails){
            Object.entries(objectDetails).map(([key, value]) => (
                detailsArr.push({
                    name:key,
                    value:value
                })
            ))
        }

        setData(detailsArr)
        console.log(objectDetails)
    },[objectDetails])

    const stopeID = objectDetails?objectDetails.Name?objectDetails.Name.endsWith('STOPE')?objectDetails.Name:null:null:null; // Example stopeID, can be null
    const summaryField = 'Month'; // Example summary field
    


  return (
    <div className="flex flex-col w-full h-full bg-gray-100 p-2 sm:p-4 overflow-y-auto">
      <div className="flex justify-between items-center mb-2">
        <h2 className="text-sm sm:text-lg font-semibold text-gray-800">{objectDetails?objectDetails.Name:'Object details'}</h2>
      </div>
      
      <div className=' min-h-64 h-96 w-full sidebarscene rounded-md z-10 shadow-lg cursor-pointer'>
        <SidebarScene objectDetailsObject={objectDetailsObject} />
      </div>
      
      
      {/* <h3 className="text-sm text-gray-900 font-medium mt-2">Description of object</h3>
      <div className="flex justify-between items-center">
        <p className="text-gray-600 text-sm">Thu, Jul 11, 2024 9:15 PM - 10:05 PM</p>
        <button className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-1 px-1 rounded inline-flex text-center items-center">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="-ml-1 mr-3 h-6 w-6">
          <path strokeLinecap="round" strokeLinejoin="round" d="M8.25 15l7.5-7.5m0 0l7.5 7.5m-7.5-7.5V21" />
        </svg>
        Copy
      </button>
      </div> */}

      {/* Collapsible Attributes Section */}
      <div className="mt-4 bg-white rounded-lg shadow-sm border border-gray-200">
        <button
          onClick={() => setIsAttributesOpen(!isAttributesOpen)}
          className="w-3/4 flex items-center justify-between p-3 text-left hover:bg-gray-50 transition-colors"
        >
          <h3 className="text-lg font-semibold text-gray-700">Attributes</h3>
          <span className={`transform transition-transform duration-200 ${isAttributesOpen ? 'rotate-180' : ''}`}>
            ▼
          </span>
        </button>
        {isAttributesOpen && (
          <div className="border-t border-gray-200">
            <div className="overflow-x-auto p-3">
              <table className="w-full table-auto">
                <thead className="bg-gray-50">
                  <tr>
                    <th className="px-4 py-2 text-left text-sm font-medium text-gray-700">Name</th>
                    <th className="px-4 py-2 text-left text-sm font-medium text-gray-700">Value</th>
                  </tr>
                </thead>
                <tbody>
                  {data.map((item, index) => (
                    <tr key={index} className={index % 2 === 0 ? 'bg-gray-50' : 'bg-white'}>
                      <td className="border-b border-gray-200 px-4 py-2 text-sm">{item.name}</td>
                      <td className="border-b border-gray-200 px-4 py-2 text-sm">{item.value}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        )}
      </div>
      

      {/* Collapsible StopeChart Section */}
      {stopeID && (
        <div className="mt-4 bg-white rounded-lg shadow-sm border border-gray-200">
          <button
            onClick={() => setIsStopeChartOpen(!isStopeChartOpen)}
            className="w-3/4 flex items-center justify-between p-3 text-left hover:bg-gray-50 transition-colors"
          >
            <h3 className="text-lg font-semibold text-gray-700">Stope Statistics</h3>
            <span className={`transform transition-transform duration-200 ${isStopeChartOpen ? 'rotate-180' : ''}`}>
              ▼
            </span>
          </button>
          {isStopeChartOpen && (
            <div className="border-t border-gray-200 p-3">
              <StopeChart
                stopeID={stopeID}
                summary_field={summaryField}
              />
            </div>
          )}
        </div>
      )}

      {/* Collapsible StopeGeology Section */}
      {stopeID && (
        <div className="mt-4 bg-white rounded-lg shadow-sm border border-gray-200">
          <button
            onClick={() => setIsGeologyOpen(!isGeologyOpen)}
            className="w-3/4 flex items-center justify-between p-3 text-left hover:bg-gray-50 transition-colors"
          >
            <h3 className="text-lg font-semibold text-gray-700">Geology</h3>
            <span className={`transform transition-transform duration-200 ${isGeologyOpen ? 'rotate-180' : ''}`}>
              ▼
            </span>
          </button>
          {isGeologyOpen && (
            <div className="border-t border-gray-200 p-3">
              <StopeGeology stopeID={stopeID} />
            </div>
          )}
        </div>
      )}

      
      
    </div>
  )
}

